module.exports = __webpack_public_path__ + "img/[冷汗].75372157.svg";